export default __webpack_public_path__ + "mini-icon-ios-17@2x.png";